export function getFirstAndLastDaysOfWeek(currentDate) {
    const day = currentDate.getDay()
    let diff = currentDate.getDate() - day + (day === 0 ? -6 : 1)
    let startDate = new Date(currentDate.setDate(diff)).toISOString().replace(/(\d{4})-(\d{2})-(\d{2}).+/, '$1-$2-$3')
    let endDate = new Date(currentDate.setDate(currentDate.getDate()+6)).toISOString().replace(/(\d{4})-(\d{2})-(\d{2}).+/, '$1-$2-$3')
    return {startDate, endDate}
}
